import Badge from "../components/ds/Badge";
import Button from "../components/ds/Button";
import PasswordField from "../components/ds/PasswordField";
import TextField from "../components/ds/TextField";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axios";

const AdminLoginPage = ({ isDark, setToast }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await api.post("/auth/signin", {
        identifier: username,
        password: password,
      });

      // Check if response has data
      if (!response.data) {
        setError("No response from server");
        setLoading(false);
        return;
      }

      // Check for success and token
      if (response.data.success && response.data.token) {
        // Store admin token and user
        localStorage.setItem("adminToken", response.data.token);
        localStorage.setItem("adminUser", JSON.stringify(response.data.user || {}));
        
        // Navigate to dashboard
        setTimeout(() => {
          window.location.href = "/admin/dashboard";
        }, 100);
      } else {
        setError(response.data?.message || "Login failed - invalid response");
        setLoading(false);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Invalid credentials");
      setLoading(false);
    }
  };

  return (
    <div
      data-theme={isDark ? "dark" : "light"}
      className="flex min-h-screen items-center justify-center bg-bg-base p-space-16 font-ds text-label-primary"
    >
      <form
        onSubmit={handleLogin}
        className="flex w-full max-w-[420px] flex-col gap-space-20 rounded-radius-xl border border-separator-default bg-bg-raised p-space-32 shadow-overlay"
      >
        <div className="flex items-center gap-space-12">
          <img src="/assets/mintly-logo.png" alt="Mintly" className="size-8" />
          <Badge>Admin</Badge>
        </div>
        <div className="flex flex-col gap-space-8">
          <h1 className="text-title-2">Admin Panel</h1>
          <p className="text-subheadline text-label-secondary">Enter admin credentials to continue</p>
        </div>
        <TextField
          label="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
          required
          autoFocus
        />
        <PasswordField
          label="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          error={error || undefined}
          required
        />
        <Button type="submit" fullWidth loading={loading}>
          {loading ? "Logging in..." : "Login"}
        </Button>
      </form>
    </div>
  );
};

export default AdminLoginPage;
